import { createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { getFixedNumber } from 'utils/general';

import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';

const getRenderedCellValue = (value: string | number | undefined | null) =>
  value === 0 ? value : getFixedNumber(value) || '-';

const columnHelper = createColumnHelper<IPrintingOrders.IWorkerItem>();

export const workersTableColumns = (t: TFunction) => [
  columnHelper.accessor('workerId', {
    cell: ({ getValue }) => getRenderedCellValue(getValue()),
    header: () => t('workerId'),
  }),

  columnHelper.accessor('entityWorkerId', {
    cell: ({ getValue }) => getRenderedCellValue(getValue()),
    header: () => t('entityWorkerId'),
  }),
  columnHelper.accessor('workerName', {
    cell: ({ getValue }) => getRenderedCellValue(getValue()),

    header: () => t('worker-name'),
  }),
];
